import React from 'react';
import JobPreperation from '../HomePages/JobPreperation/JobPreperation';

const JobPages = () => {
    return (
        <div>
            <JobPreperation/>
        </div>
    );
};

export default JobPages;